import * as React from 'react';
import styles from './style.css';
import UQButton from '../../../../uq-ui/components/button';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../../../../modules/icons/Icon';
import UiIcon from "../../../../uq-ui/components/ui-icon";
import { useTranslation } from 'react-i18next';
import { currentUserInfoSelector, moderatorModeSelector } from '../../../../../modules/auth/store/auth-user/selectors';
import { useParams } from 'react-router';
import { useStickerItem } from '../../../store/sticker-show/hooks';
import ConfirmModal from '../../../../../modules/uq-ui/components/confirm-modal';
import { deleteStickerItem } from '../../../store/entities/sticker-items/actions';

export function GridItem({
  name,
  date,
  background,
  foreground,
  id,
  onClick,
}: {
  name?: string | null;
  date?: string | null;
  background: string[];
  foreground?: any;
  id: string;
  onClick: () => any;
}) {
  const image = background[0]; // We assume 1 image for now
  const { t } = useTranslation('scr-show-sticker-item');
  const [confirmStickerDelete, setConfirmStickerDelete] = React.useState(false);
  const currentUser = useSelector(currentUserInfoSelector);
  const { id: stickerId }: { id: string } = useParams();
  const [stickerItem] = useStickerItem(stickerId, id);
  const isMySticker = currentUser.id === stickerItem?.from?.id;
  const canModerate = useSelector(moderatorModeSelector);
  // Owners delete on memorial stickers only; moderators/admins on any sticker
  // while moderator mode is on (the server enforces the role, not the mode).
  const canDelete = canModerate || (isMySticker && stickerItem?.type === 'MEMORIAL');
  const dispatch = useDispatch();

  // The trash button goes straight to the confirmation modal.
  const onDelete = (e: Event) => {
    e.stopPropagation();
    setConfirmStickerDelete(true);
  };

  const onModalDeleteClick = (e: Event) => {
    e.stopPropagation();
    setConfirmStickerDelete(false);
    dispatch(deleteStickerItem(stickerItem));
  };

  const onModalDeleteClose = (e: Event) => {
    e.stopPropagation();
    setConfirmStickerDelete(false);
  };

  return (
    <div className={styles.container} style={{ backgroundImage: 'url("' + image + '")' }} onClick={onClick}>
      {!!foreground && <div className={styles.foreground}>{foreground}</div>}
      <UiIcon className={styles.expandIcon} name="expand" size={22} color="#FFFFFF"/>
      {(name || date) && (
        <div className={styles.strip}>
          {name && <div className={styles.textAuthor}>{name}</div>}
          {date && <div className={styles.textDate}>{date}</div>}
          <div className={styles.deleteButton}>
            {canDelete && (
              <UQButton
                theme="brand"
                justIcon={true}
                label={''}
                containerStyle={{ width: '44px' }}
                icon={<UiIcon name="trash" size={20} color="var(--c-on-accent)"/>}
                onPress={onDelete}
              />
            )}
          </div>
        </div>
      )}
      {/* Clicks inside the modal must not reach the tile (which opens the media). */}
      <div onClick={(e) => e.stopPropagation()}>
      <ConfirmModal
        show={confirmStickerDelete}
        title={t('deleteTitle')}
        styles={{ zIndex: 105 }}
        showConfirmBtn={false}
        onClose={onModalDeleteClose}>
        <div className={styles.deleteModelContainer}>
          {t('deleteMessage')}
          <UQButton label={t('deleteButton')} containerClass={styles.attachFloatButton} theme={'danger'} onPress={onModalDeleteClick} />
        </div>
      </ConfirmModal>
      </div>
    </div>
  );
}
